import React from "react";
import "../App.css";
import { useRef } from "react";
import emailjs from '@emailjs/browser'

const Join = () => {
    const form =useRef()
    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_0yt6rf6', 'template_owucwx2', form.current, 'ynj48DtbKRR-XZ3ap')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });}
  return (
    <div className="Join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span>READY TO</span>
          <span>LEVEL UP</span>
        </div>
        <div>
          <span>YOUR BODY</span>
          <span>WITH US?</span>
        </div>
      </div>
      <div className="right-j">
        <form action="" className="email-container" ref={form} onSubmit={sendEmail}>
          <input
            type="email"
            name="user_email"
            placeholder="Enter your Email address"
          />
          <button className="btn btn-j">Join Now</button>
        </form>
      </div>
    </div>
  );
};

export default Join;
